import { tokenStorage } from '../storage/tokenStorage.js';
import { aggregatesMethods } from './apiClient.aggregates.js';
import { authAdminMethods } from './apiClient.authAdmin.js';
import { bankAccountsMethods } from './apiClient.bankAccounts.js';
import { ApiClientCore } from './apiClient.core.js';
import { commsMethods } from './apiClient.comms.js';
import { devMethods } from './apiClient.dev.js';
import { outboxMethods } from './apiClient.outbox.js';
import { rbacMethods } from './apiClient.rbac.js';
import { reconciliationMethods } from './apiClient.reconciliation.js';

export {
  ApiError,
  parseEntitlementDenialKindsFromApiError,
  parseEntitlementDenials,
  parseEntitlementDenialsFromApiError,
  type ApiErrorDetails,
  type ApiErrorEntitlementDenial,
  type ApiErrorEnvelope,
  type ApiResponse,
  type RequestAuthMode,
  type ExecutiveAggregateStatus,
  type WatermarkDayRow,
  type AggregateObservabilityResponse,
  type AggregateRecordedMaterialization,
  type AggregateRecordedDriftAlert,
} from './apiClient.types.js';

export { ApiClientCore, createXRequestId } from './apiClient.core.js';

/** G4 — path denylist + ApiClientCore 401 cookie-refresh handler. */
export {
  ADMIN_REFRESH_401_DENY_SUBSTRINGS,
  shouldAttemptRefreshOn401,
} from '../../shared/session/adminRefreshCoordinator.js';

/**
 * G24 (gateway-inventory): Pass — ApiClientCore always `credentials:'include'`.
 * Residual / Locked dual-only (G11) — singleton still injects `tokenStorage.get()` for
 * dual / mode=off Bearer. Cookie-first sessions with null memory rely on credentials;
 * stale LS Bearer attach remains until K7 removes mode=off `get()` (not surgical here —
 * FE has no cookie-mode flag; changing to memory-only would break mode=off LS auth).
 */

type ApiClientDomainMethods =
  typeof authAdminMethods &
  typeof bankAccountsMethods &
  typeof devMethods &
  typeof rbacMethods &
  typeof outboxMethods &
  typeof reconciliationMethods &
  typeof aggregatesMethods &
  typeof commsMethods;

export interface ApiClient extends ApiClientCore, ApiClientDomainMethods {}

export class ApiClient extends ApiClientCore {}

Object.assign(
  ApiClient.prototype,
  authAdminMethods,
  bankAccountsMethods,
  devMethods,
  rbacMethods,
  outboxMethods,
  reconciliationMethods,
  aggregatesMethods,
  commsMethods
);

export const apiClient = new ApiClient(() => tokenStorage.get());
